import useIsLocal from 'shared/hooks/use-is-local';
import { checkIsDev } from 'shared/utils/check-is-dev';

/**
 * True only on the deployed TEST environment (admin.test.imgameapp.ru), built by
 * `.github/workflows/test-ci.yml` with `REACT_APP_ENVIRONMENT=development` via `craco build`.
 *
 * Distinguished from the other environments by two facts:
 *  - `checkIsDev()` is true          → `REACT_APP_ENVIRONMENT !== 'production'` (rules PROD out)
 *  - it is not a local dev server    → `NODE_ENV === 'production'` (rules the local server out)
 *
 * | env       | NODE_ENV      | REACT_APP_ENVIRONMENT | useIsTest |
 * |-----------|---------------|-----------------------|-----------|
 * | local     | 'development' | —                     | false     |
 * | TEST      | 'production'  | 'development'         | true      |
 * | PROD      | 'production'  | 'production'          | false     |
 *
 * Use this (not `checkIsDev`, which is also true on the local dev server, nor `useIsLocal`, which is
 * only true locally) to target strictly the deployed TEST build.
 */
function useIsTest(): boolean {
  const dev = checkIsDev();
  const local = useIsLocal();
  return dev && !local;
}

export default useIsTest;
